/**
 * ProtectedRoute - guard component.
 *
 * Sprawdza useAuth - jezeli zalogowany, renderuje children/outlet.
 * Jezeli nie, redirect na /auth?redirect=<current_path>.
 * Podczas auth check (isLoading=true) pokazuje spinner zeby nie flash'owalo "/auth" zanim
 * Supabase odda session.
 */
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";

export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!isAuthenticated) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/auth?redirect=${redirect}`} replace />;
  }

  return <Outlet />;
}
